module.exports = __webpack_public_path__ + "img/branding.48036f2e.gif";